export default {
  tablacargos:{
    items:[],
    fields: [
      {
        key: 'DisplayUnidadAdministrativaNivel',
        label: 'Establecimiento',
        formatter: 'valueFormatter',
        tdClass: 'text-left'
      },
      {
        key: 'DisplayCargo',
        label: 'Cargo',
        formatter: 'valueFormatter',
        tdClass: 'text-left'
      },
      {
        key: 'DisplayHoras',
        label: 'Horas',
        formatter: 'valueFormatter',
        tdClass: 'text-left'
      },
      {
        key: 'SituacionRevista',
        label: 'Revista',
        formatter: 'valueFormatter'
      },
      {
        key: 'acciones',
        label: 'Acciones'
      }
    ]
  },
}




// WEBPACK FOOTER //
// ./src/constantes.js